(function() {
  'use strict';
  // Using this hack, mainly for -webkit-line-clamp to repaint.
  // Without this, the element renders without an ellipsis
  angular.module('ringbaPortal').directive('repaintCss', repaintCss);

  function repaintCss(
    $timeout
  ) {
    'ngInject';

    const directive = {
      restrict: 'A',
      link: link
    };
    return directive;

    function link(scope, element, attributes) {
      $timeout(function () {
        element[0].setAttribute('style', attributes.repaintCss);
      }, 0);
    }
  }

})();
